import { apiClient } from './api-client';
import type { DashboardStats } from '../types/dashboard';

export async function fetchDashboardStats(): Promise<DashboardStats> {
  return apiClient<DashboardStats>('/admin/dashboard/stats');
}
